import ReactDOM from "react-dom"
import React, { useState } from "react"
import PropTypes from "prop-types"
import * as Sentry from "@sentry/browser"

import { isMobile } from "../../utils/device"
import { getFormattedError } from "../../utils/sanitization"
import { getElementNode } from "../../services/elementNode"

import Snackbar from "@material-ui/core/Snackbar"
import Alert from "@material-ui/lab/Alert"

import InfoModal from "../InfoModal"

const Notification = (props) => {
	const { message, type } = props

	const [visibility, setVisibility] = useState(true)

	const place = {
		vertical: isMobile() ? "bottom" : "top",
		horizontal: isMobile() ? "center" : "right"
	}

	const handleClose = () => {
		setVisibility(false)
	}

	return (
		<Snackbar
			open={visibility}
			autoHideDuration={3000}
			onClose={handleClose}
			anchorOrigin={place}
		>
			<Alert onClose={handleClose} variant="filled" severity={type}>
				{message}
			</Alert>
		</Snackbar>
	)
}

Notification.propTypes = {
	message: PropTypes.string.isRequired,
	type: PropTypes.oneOf(["success", "error"])
}

Notification.success = (message) => {
	const notificationNode = getElementNode("notification-node")

  ReactDOM.render(<Notification message={message} type="success" />, notificationNode);
}

Notification.error = (message) => {
	const notificationNode = getElementNode("notification-node")

  ReactDOM.render(<Notification message={message} type="error" />, notificationNode);
}

Notification.undeterminedError = (error) => {
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN, environment: process.env.REACT_APP_SENTRY_ENVIRONMENT });

  const formattedError = getFormattedError(error);

  class UndeterminedError extends Error {
    constructor(args) {
      super(args);
      this.name = "UndeterminedError";
    }
  }

  Sentry.captureException(new UndeterminedError(JSON.stringify(formattedError, null, 2)));

  InfoModal.error({
    title: "Algo deu errado",
    message: (
      <>
        Parece que ocorreu algum erro inesperado :(
        <br />
        <br />
        Por favor tire um print dessa tela e
        {window.innerWidth > 400 ? <br /> : " "}
        mostre para o nosso suporte para
        {window.innerWidth > 400 ? <br /> : " "}
        solucionarmos o seu problema.
        <br />
        <br />
        <div style={{ backgroundColor: "#ECECEC", padding: "10px" }}>
          {formattedError.summarizedError}
        </div>
      </>
    )
  })
}

export default Notification